
import { Component, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';

import { StatesProcessParentService } from './../utils/states-process-parent.service';
import { ContextFactory } from '@shared/factories/context/context.factory';


@Component({
  selector: 'states-process-default',
  templateUrl: './states-process-default.component.html'
})
export class StatesProcessDefaultComponent implements OnChanges {
  skin: string = this.globalCfg.skin;
  isLanding: any = false;
  adviceModalSubject:any;
  evaluationId: any = this.route.snapshot.params['evaluationId']
  statesProcess:any = {
    arrowsPrev: '<<',
    arrowsAfter: '>>',
    statesList: [],
    showStates: false,
    showQuestion: false,
    canChangeState: false,
    canAddAlerts: false,
    titleHeader: this.translate.instant('states-task-help.task-states'),
    iconName: this.translate.instant('states-process.view-proccess'),
    summary:{
      current: {}
    },
    userId: this.context.user.userId? (this.context.user.userId + 'U').toString() : (this.context.user.contactId + 'C').toString()
   
  }

  constructor(private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private route: ActivatedRoute,
    private statesProcessParent: StatesProcessParentService,
    private context: ContextFactory) {
  }

  @Input() type:any = null;
  @Input() item:any = null;
  @Input() concept:any = null;
  @Input() userPublic:any = null;
  @Input() typeView:string = 'normal';

  @Output() changeResponsible:any = new EventEmitter();
  @Output() changeState:any = new EventEmitter();
  @Output() changeLockedEdit:any = new EventEmitter();
  @Output() changeStateModal:any = new EventEmitter();


  

  ngOnChanges(): void {
    this.statesProcessParent.configureChanges(this);
  }

  

  changeProcessQuestion(itemSelected:any, option:any) {
    this.statesProcessParent.changeProcessQuestion(itemSelected, option, this);
  }

  confirmChange(){
    this.statesProcessParent.confirmChange(this);
  }

  showProcessModal() {
    this.statesProcessParent.showProcessModal(this);
  }
}
